module.exports = __webpack_public_path__ + "img/2c2d4f4baaa9782d320fade2f84a4bb5680e0b32.ff26988d.png";